<template>
  <div class="content-share-container">
    <div class="content-share">
      <van-search
        v-model="searchValue"
        shape="round"
        placeholder="请输入搜索关键词"
      />
      <div class="c-serach-box">
        <van-dropdown-menu active-color="#aa341b">
          <van-dropdown-item
            v-model="selectedPathology"
            :options="pathologies"
            get-container="body"
            @change="onFilterChange"
          />
        </van-dropdown-menu>
        <van-dropdown-menu active-color="#aa341b">
          <van-dropdown-item
            v-model="selectedSection"
            :options="sections"
            get-container="body"
            @change="onSectionChange"
          />
        </van-dropdown-menu>
      <!-- <van-dropdown-menu active-color="#aa341b">
        <van-dropdown-item
          v-model="selectedCategory"
          :options="categories"
          get-container="body"
          @change="onFilterChange"
        />
      </van-dropdown-menu> -->
      <!-- <van-dropdown-menu active-color="#aa341b" style="margin-right: 40px">
        <van-dropdown-item
          v-model="selectedProduct"
          :options="userProduct"
          get-container="body"
        />
      </van-dropdown-menu> -->
      <!-- <div class="c-serach-item">
        <div class="c-s-label" style="font-size: 13px">标签筛选：</div>
        <div class="flex flex-wrap" style="margin-bottom: -10px">
          <div
            v-for="(se, index) in tagList"
            :key="index"
            style="margin-bottom: 10px; font-size: 11px"
            class="c-s-item"
            :class="{active: se.active}"
            @click="changeTag(se)"
          >
            <div class="c-s-flex">{{ se.product_name }}</div>
          </div>
        </div>
      </div> -->
      </div>
      <van-loading
        v-if="loading"
        style="text-align: center; margin-top: 80px; margin-bottom: 40px"
        type="spinner"
        color="#aa341b"
      />
      <div v-if="hasNbaContentContext" class="nba-content-context">
        <div class="nba-context-title">
          <van-icon name="newspaper-o" />
          <span>{{ $t('recommended_content') }}</span>
        </div>
        <div v-if="recommendedContentTitle" class="nba-context-content-title">
          {{ recommendedContentTitle }}
        </div>
        <div v-if="recommendedTopic" class="nba-context-topic">
          {{ recommendedTopic }}
        </div>
        <div v-if="recommendedContentId" class="nba-context-id">
          Content ID: {{ recommendedContentId }}
        </div>
      </div>
      <div v-if="contentsList.length">
        <div class="action-plan">
          <!-- {{ nbaKeyMessages }} -->
          <div v-for="(item, index) in contentsList" :key="index">
            <div class="action-text flex">
              <div class="thumb-col" @click="previewContent(item)">
                <div v-if="item.thumb && item.thumb.length" class="thumb">
                  <img :src="item.thumb" />
                </div>
                <div v-else class="thumb thumb-placeholder">
                </div>
                <div class="date-text" style="font-size: 12px; color: #999; text-align: left;">
                  {{ item.publish_date ? item.publish_date.split('T')[0] : '' }}
                </div>
              </div>
              <div class="content-col" @click="previewContent(item)">
                <!-- <span class="action-flag"></span> -->
                <span class="title">{{ item.content_name }}</span>
                <div class="tags-container" style="margin-top: 4px;">
                  <span v-if="item.is_promo === 0" class="key-message-labels">
                    {{ item.is_promo ? '推广' : '非推广' }}
                  </span>
                  <!-- 疾病标签 -->
                  <span
                    v-for="(disease, dIdx) in item.content__content_pathologies || []"
                    :key="'disease-' + dIdx"
                    class="key-message-labels"
                  >
                    {{
                      (pathologies.find(p => p.value === disease.pathology_id) || {}).text || disease.pathology_id
                    }}
                  </span>
                <!-- 产品标签 -->
                <!-- <span
                  v-for="(prod, pIdx) in item.content__content_products || []"
                  :key="'product-' + pIdx"
                  class="key-message-labels"
                >
                  {{
                    (products.find(p => p.value === prod.product_id) || {}).text || prod.product_id
                  }}
                </span> -->
                </div>
                <p v-if="item.comment" class="comment">
                  {{ item.comment }}
                </p>
              </div>
              <span class="buttons">
                <div class="cp-share" @click.stop="choosePhysician(item)">
                  <div class="share-icon-bg">
                    <van-icon name="share" color="#fff" size="14" />
                  </div>
                  <span class="share-text" style="color: #aa341b;">发送</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else-if="!loading" description="暂无内容" />
    </div>

    <transition name="slide-right">
      <swipeDialog
        v-if="htmlContent || pdfLink"
        backtxt="返回"
        :title="'内容预览'"
        :visible="true"
        @closeFn="closePreviewFn"
      >
        <van-loading v-if="fileLoading" class="loading">加载中...</van-loading>
        <div v-if="htmlContent" class="html-preview" v-html="htmlContent"></div>
        <pdf v-show="pdfLink" :src="pdfLink" />
      </swipeDialog>
    </transition>
    <DoctorListSelectAll
      v-if="showDoctorSelect"
      :multiple-mode="false"
      :default-selected-list="doctors"
      @close="showDoctorSelect = false"
      @select="handleSelectDoctor"
    />
  </div>
</template>

<script>
import * as py from '@/api/Physicians';
import * as contentApi from '@/api/content';
import {
  Search,
  Loading,
  ImagePreview,
  Empty,
  DropdownMenu,
  DropdownItem,
  Icon,
} from 'vant';
import swipeDialog from '@/views/layout/swipeDialog';
import {getLocalStorage, isGBA} from '@/utils';
import DoctorListSelectAll from '@/components/DoctorListSelectAll.vue';
import {wecomSDK} from '@/utils/wecom';
import {getMimeTypeBySuffix} from '@/utils/index';
import {selectRecommendedWording} from '@/utils/recommendedWording';
import pdf from 'vue-pdf';
// import pdfComponent from '@/views/hcp/components/pdfComponent.vue';
export default {
  name: 'ContentShare',
  components: {
    [Search.name]: Search,
    [Icon.name]: Icon,
    swipeDialog,
    DoctorListSelectAll,
    // pdfComponent,
    pdf,
    [Empty.name]: Empty,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    vanLoading: Loading,
  },
  data() {
    return {
      searchValue: '',
      loading: true,
      contentsList: [],
      pdfLink: null,
      pdfKey: null,
      showDoctorSelect: false,
      doctors: [],
      targetPhysicianId: '',
      targetPhysicianName: '',
      nbaSuggestionId: '',
      recommendedTopic: '',
      recommendedContentId: '',
      recommendedContentTitle: '',
      forwardContent: {
        id: '',
        title: '',
        physicianId: '',
        description: '',
        wxLogo: '',
      },
      detailStatus: false,
      fileLoading: false,
      userProduct: [],
      tagList: [
        {
          product_name: '图文',
          product_id: '图文',
          active: true,
        },
        {
          product_name: '幻灯',
          product_id: '幻灯',
          active: true,
        },
      ],
      selectedProduct: '',
      selectedPathology: '',
      products: [],
      pathologies: [],
      selectedSection: '',
      sections: [],
      selectedCategory: '',
      categories: [],
      htmlContent: null,
    };
  },
  computed: {
    hasNbaContentContext() {
      return !!(this.recommendedTopic || this.recommendedContentId || this.recommendedContentTitle);
    },
  },
  watch: {
    searchValue(val) {
      this.fetchContents();
    },
  },
  mounted() {
    this.initTargetPhysician();
    this.fetchOptions();
    // this.fetchContents();
    this.fetchProduct();
  },
  methods: {
    fetchOptions() {
      contentApi.getKvpByKvpId('product').then((res) => {
        this.products = res.value.map((item) => {
          return {
            text: item.kvp_key_name,
            value: item.kvp_key_id,
          };
        });
      });
      contentApi.getPathologies().then((res) => {
        let filteredPathologies = res.value;
        if (isGBA()) {
          // GBA角色：只获取偏头痛的病理，不受is_promo限制
          filteredPathologies = res.value.filter(item => item.pathology_name === '偏头痛');
          // 直接选中偏头痛
          if (filteredPathologies.length > 0) {
            this.selectedPathology = filteredPathologies[0].pathology_id;
          }
        } else {
          // 非GBA角色：保留is_promo不为0的病理
          filteredPathologies = res.value.filter(item => item.is_promo !== 0);
        }

        this.pathologies = [
          {
            text: '全部领域',
            value: '',
          },
          ...filteredPathologies.map((item) => {
            return {
              text: item.pathology_name,
              value: item.pathology_id,
            };
          }),
        ];
      });
      contentApi.getKvpByKvpId('content_section').then((res) => {
        this.sections = [
          {
            text: '全部板块',
            value: '',
          },
          ...res.value.map((item) => {
            return {
              text: item.kvp_key_name,
              value: item.kvp_key_id,
            };
          }),
        ];
        this.onSectionChange();
      });
    },
    onSectionChange() {
      this.selectedCategory = '';
      if (this.selectedSection === '') {
        contentApi.getKvpByKvpId('content_category').then((res) => {
          this.categories = [
            {
              text: '全部分类',
              value: '',
            },
            ...res.value.map((item) => {
              return {
                text: item.kvp_key_name,
                value: item.kvp_key_id,
              };
            }),
          ];
          this.fetchContents();
        });
      } else {
        contentApi.getKvpByKvpIdAndParent('content_category', this.selectedSection).then((res) => {
          this.categories = [
            {
              text: '全部分类',
              value: '',
            },
            ...res.value.map((item) => {
              return {
                text: item.kvp_key_name,
                value: item.kvp_key_id,
              };
            }),
          ];
          this.fetchContents();
        });
      }
    },
    onFilterChange() {
      this.fetchContents();
    },
    fetchContents() {
      if (this.recommendedContentId) {
        this.fetchRecommendedContent();
        return;
      }
      contentApi.getContents(
        this.searchValue || '',
        this.selectedPathology,
        this.selectedSection,
        this.selectedCategory,
      ).then((res) => {
        if (res.value) {
          this.contentsList = res.value;
        }
        this.loading = false;
      });
    },
    fetchRecommendedContent() {
      this.loading = true;
      contentApi.getContentById(this.recommendedContentId).then((res) => {
        const list = res && Array.isArray(res.value)
          ? res.value
          : (res && Array.isArray(res.data) ? res.data : []);
        this.contentsList = list;
        if (list.length && !this.recommendedContentTitle) {
          this.recommendedContentTitle = list[0].content_name || '';
        }
      }).catch((error) => {
        console.error('Failed to fetch recommended content:', error);
        this.contentsList = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    fetchProduct() {
      py.getUserProduct(getLocalStorage('user_id')).then((res) => {
        this.userProduct = [
          {
            text: '全部产品',
            value: '',
          },
          ...res.value.map((item) => {
            return {
              text: item.product_name,
              value: item.product_id,
            };
          }),
        ];
      });
    },
    closePreviewFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.pdfLink = null;
      this.htmlContent = null;
    },
    initTargetPhysician() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      this.targetPhysicianId = query.physician_id || '';
      this.targetPhysicianName = query.physician_name || '';
      this.nbaSuggestionId = query.nba_suggestion_id || '';
      this.recommendedTopic = query.recommended_topic || '';
      this.recommendedContentId = query.recommended_content_id || '';
      this.recommendedContentTitle = query.recommended_content_title || '';
      if (!this.recommendedContentId && this.recommendedContentTitle) {
        this.searchValue = this.recommendedContentTitle;
      }
      if (this.targetPhysicianId) {
        this.doctors = [{
          physician_id: this.targetPhysicianId,
          physician_name: this.targetPhysicianName
        }];
      }
    },

    choosePhysician(content) {
      console.log(content);
      this.forwardContent.id = content.content_id;
      this.forwardContent.title = content.content_name;
      this.forwardContent.description = content.description;
      this.forwardContent.recommendedWording = content.recommended_wording;
      this.forwardContent.wxLogo = content.wx_logo;
      if (this.targetPhysicianId) {
        this.forwardContent.physicianId = this.targetPhysicianId;
        this.forwardWechat();
        return;
      }
      this.showDoctorSelect = true;
    },
    handleSelectDoctor(doctors) {
      console.log(doctors);
      this.forwardContent.physicianId = doctors[0].physician_id;
      this.doctors = doctors;
      this.showDoctorSelect = false;
      this.forwardWechat();
    },
    async forwardWechat() {
      console.log('forward', this.forwardContent.title);
      const toast = this.$createToast({
        time: 10000,
        mask: false,
      });
      toast.show();
      // 检查是否有建议话术
      if (this.forwardContent.recommendedWording) {
        try {
          const wordingToCopy = await selectRecommendedWording(this.forwardContent.recommendedWording, {
            title: '建议话术',
            confirmButtonText: '复制话术',
            cancelButtonText: '跳过',
          });

          if (wordingToCopy) {
            const success = await wecomSDK.copyToClipboard(wordingToCopy);
            if (success) {
              // this.$toast.success('复制成功');
            } else {
              this.$toast.fail('复制失败');
            }
          }
        } catch (err) {
          console.log(err);
          // 忽略 Dialog cancel 的错误，继续执行
        }
      }

      try {
        const success = await wecomSDK.shareWechatMessage({
          content_id: this.forwardContent.id,
          sender_user_id: getLocalStorage('user_id'),
          sender_user_name: getLocalStorage('user_name'),
          sender_territory_id: getLocalStorage('territory_id'),
          receiver_physician_id: this.forwardContent.physicianId,
          send_time: new Date(),
          title: this.forwardContent.title,
          description: this.forwardContent.description,
          wx_logo: this.forwardContent.wxLogo,
          // url: 'https://hcp360-mobile-sandbox.lundbecksys.cn/resource/nba/azilect/azilect-slides-001.pdf',
        });
        if (success !== false) {
          await this.submitNbaSuggestionFeedback();
        }
      } catch (err) {
        this.$toast.fail('转发失败，请稍后重试');
      }
      toast.hide();
    },
    async submitNbaSuggestionFeedback() {
      if (!this.nbaSuggestionId) return;

      try {
        await py.saveNbaSuggestionFeedback({
          nba_suggestion_id: this.nbaSuggestionId,
          feedback_status: 'accepted',
          reject_reason: '',
          feedback_comment: 'send_content',
          user_id: getLocalStorage('user_id'),
          territory_id: getLocalStorage('territory_id'),
          territory_type: getLocalStorage('territory_type'),
          role_id: getLocalStorage('role_id')
        });
        this.nbaSuggestionId = '';
      } catch (e) {
        console.error('Save NBA content push feedback failed', e);
      }
    },
    previewContent(item) {
      if (item.content_body) {
        this.htmlContent = item.content_body;
        this.$store.dispatch('setDialogStatus', true);
      } else if (item.s3_file_name) {
        const slides = item.s3_file_name;
        console.log('slides----->', slides);
        if (slides) {
          if (slides.indexOf('.pdf') > 0) {
            this.getPictureUrl(slides);
          } else {
            let images = [];
            slides.split(',').forEach((image) => {
              images.push('/resource/nba/brintellix/key-message/' + image);
            });
            ImagePreview({
              images: images,
              loop: false,
              showIndicators: true,
            });
          }
        // } else {
        //   this.$router.push({
        //     path: '/hcp/live'
        //   });
        }
      }
    },
    getPictureUrl(key) {
      console.log('cnm---->', key);
      py.getS3ByKey(key).then((res) => {
        let currentMimeType = getMimeTypeBySuffix(
          key.split('.').pop().toLowerCase(),
        );
        let blob = new Blob([res.data], {
          type: currentMimeType,
        });
        this.pdfKey = key;
        this.pdfLink = window.URL.createObjectURL(blob);
        this.fileLoading = false;
        this.$store.dispatch('setDialogStatus', true);
      });
    },
    changeTag(se) {
      console.log(se);
      se.active = !se.active;
      this.fetchContents();
    },
  },
};
</script>
<style lang="scss" scoped>
.content-share-container {
  height: 100vh;
  overflow: hidden;
  background: #f2f5f9;
}
.content-share {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: auto;
  // background: #fff;
  // padding: 10px;
}
.c-serach-box {
  //   margin-top: 20px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 0 20px 0 10px;
  margin-bottom: 10px;
  // justify-content: space-between;
  ::v-deep .van-dropdown-menu__bar {
    box-shadow: none;
  }
}
.action-plan {
  padding: 0 4px 70px 4px;
  height: calc(100vh - 190px);
  overflow: auto;
}
.thumb-col {
  flex: 0 0 auto;
  margin-right: 10px;
  width: 120px;
  display: flex;
  flex-direction: column;

  .thumb {
    img {
      width: 100%;
      border: 1px solid #f0f0f0;
      border-radius: 8px;
    }
  }

  .thumb-placeholder {
    width: 100%;
    /* Maintain approx aspect ratio or fixed height? Assuming similar height to img */
    padding-bottom: 42.6%; /* 1000:426 aspect ratio approximately */
    background-color: #f2efe8;
    border-radius: 8px;
  }
}

/* 中间内容列：允许收缩并截断溢出 */
.content-col {
  flex: 1;
  min-width: 0;        /* 关键：允许内容在 flex 中收缩 */
  overflow: hidden;
  margin-right: 5px;   /* Just 5px gap as requested */
}

/* 标题单行省略（需要多行时见下方可选方案） */
.title {
  font-size: 13px;
  font-weight: 400;
  /* 多行省略（改为3行） */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; // 2 -> 3
  overflow: hidden;

  /* 处理超长英文/URL */
  word-break: break-all; /* 或 overflow-wrap: anywhere; */
}

/* 不支持 -webkit-line-clamp 的浏览器降级为单行省略 */
@supports not (-webkit-line-clamp: 3) { // 2 -> 3
  .title {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

/* 确保中间列可收缩，避免被右侧按钮挤出屏幕 */
.action-text > span:nth-child(2) {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

/* 右侧按钮固定宽度，不参与伸缩，避免把中间列挤爆 */
.action-text > span.buttons {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
}

/* 兜底：极端情况下隐藏横向溢出 */
.content-share {
  overflow-x: hidden;
}

.action-text {
  // 已是 flex
  box-sizing: border-box;
}

.key-message-labels {
  background: rgba(231, 229, 226, 0.8);
  border-radius: 4px;
  font-size: 10px;
  color: #333;
  white-space: nowrap;
  padding: 2px 6px;
  margin: 2px 2px 0 4px;
}
.product-outlined > span {
  background: #fff;
  border: 1px solid #aa341b;
  color: #aa341b;
}
.action-highlight {
  font-size: 16px;
  font-family: Arial;
  font-weight: 700;
  color: #aa341b;
  opacity: 1;
  text-align: left;
  line-height: 1.4;
  margin-bottom: 15px;
  .action-flag {
    background: #aaa;
  }
  span {
    font-weight: 700;
  }
}

.nba-content-context {
  margin: 0 0 10px;
  padding: 10px 12px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
  text-align: left;
}

.nba-context-title {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #1f6fb5;
  font-size: 12px;
  font-weight: 600;
}

.nba-context-content-title {
  margin-top: 6px;
  color: #2c3034;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.nba-context-topic,
.nba-context-id {
  margin-top: 5px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.45;
}

.cp-share {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  margin-right: 2px;
  margin-top: 2px;

  .share-icon-bg {
      width: 24px;
      height: 24px;
      background: linear-gradient(165deg, rgb(210, 86, 61), rgb(170, 52, 27));
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 2px;
    }

  .share-text {
    font-size: 10px;
  }
}

.action-tag {
  color: #ab351c;
}
.highlight {
  color: #aa341b;
}
.action-progress {
  display: flex;
  align-items: center;
  height: 30px;
  background: rgba(236, 233, 223, 0.5);
  border-radius: 4px;
  margin-bottom: 20px;
  p {
    color: #aa341b;
    font-size: 14px;
    font-family: Arial;
    font-weight: 700;
    margin-left: 10px;
  }
}
.action-no-data {
  padding: 20px;
  color: #999;
}
.active-text {
  /* ... existing styles ... */
  display: flex !important; /* Ensure it overrides any other display property */
  justify-content: flex-start !important; /* Force items to start from left, removing gap between title and button */
}

.action-text {
  font-size: 14px;
  font-family: Arial;
  font-weight: 400;
  color: #2c3034;
  opacity: 1;
  text-align: left;
  line-height: 1.3;
  margin-bottom: 10px;
  display: flex; /* Ensure flex display */
  justify-content: flex-start; /* Changed from space-between to eliminate large gap */
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #f4f4f4;
  background: #fff;

  span.buttons {
    display: flex;
    justify-content: flex-end;
    flex: 0 0 auto;
    margin-left: 5px; /* Only 5px gap as requested */

    img {
      display: inline-block;
      width: 26px; // 64 x 96
      height: 39px;
    }
  }
}

.comment {
  margin: 3px 0 4px 0;
  font-size: 11px;
  font-style: italic;
  color: #999;
}

.action-flag {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #aa341b;
  opacity: 1;
  border-radius: 4px;
  margin: 0 5px 2px 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
}
.html-preview {
  padding: 0;
  max-width: 100%;
  overflow: auto;
  ::v-deep img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
